'use strict';

export function init() {
  const globalAlerts = document.querySelector('.global-alerts');
  const globalHeader = document.querySelector('.js-global-header');
  const globalHeaderSticky = document.querySelector('.global-header');

  if (!globalHeader) return;

  const setGroupHeight = () => {
    const alertsHeight = globalAlerts ? globalAlerts.offsetHeight : 0;
    const headerHeight = globalHeaderSticky ? globalHeaderSticky.offsetHeight : 0;

    document.documentElement.style.setProperty(
      '--global-header-height', `${alertsHeight + headerHeight}px`
    );
  };

  // Use a ResizeObserver to detect changes in the size of .global-alerts
  if ('ResizeObserver' in window && globalAlerts) {
    const resizeObserver = new ResizeObserver(() => {
      setGroupHeight();
    });
    resizeObserver.observe(globalAlerts);
  }

  setGroupHeight();
  window.addEventListener('resize', setGroupHeight);
}
